module.exports = __webpack_public_path__ + "images/feature/20160720_3-7febc7698b1d2c4a7a5145490f7d6db3.jpg";